<template>
    <div class="flex items-center justify-between gap-2 min-w-0">
        <vx-badge class="cursor-pointer" @click.prevent="copyText(props.modelValue.id)" size="xs" color="slate">
            <copy-button label="resource ID" :value="props.modelValue.id" />
        </vx-badge>

        <div
            class="font-bold text-slate-700 text-lg wrap-anywhere min-w-0 cursor-pointer"
            @click.prevent="copyText(props.modelValue.name)"
        >
            <copy-button label="resource name" :value="props.modelValue.name" class="text-left">
                <font-awesome-icon widthAuto v-if="props.icon" :icon="resourceTypeIcon(props.modelValue.resource_type)" class="mr-2 text-slate-500 text-sm"></font-awesome-icon>
                {{ props.modelValue.name }}
            </copy-button>
        </div>
    </div>

</template>
<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    VxBadge,
} from '@voxie/frontend-components';
import CopyButton from '~/components/general/CopyButton.vue';
import { useCopyText } from '~/composables/useCopyText';
import { resourceTypeIcon } from '~/utils/analytics';

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
    icon: {
        type: Boolean,
        default: false,
    }
});

const { copyText } = useCopyText();
</script>
